import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation, Scrollbar]);

export default class CollectionBannerCarousel {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * collections banner carousel element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        this.init();
    }

    init() {
        const _this = this;
        new Swiper(this.sliderElement, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            threshold: 10,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true
            },
            breakpoints: {
                768: {
                    spaceBetween: 16
                }
            },
            on: {
                init () {
                    _this.toggleNavigationButtons(this);
                },
                reachBeginning () {
                    _this.toggleNavigationButtons(this);
                },
                reachEnd () {
                    _this.toggleNavigationButtons(this);
                },
                fromEdge () {
                    _this.toggleNavigationButtons(this);
                },
            }
        });
    }

    toggleNavigationButtons(swiper) {
        const hiddenClass = 'swiper-button-hidden';

        // Prev button visibility
        if (swiper.isBeginning) {
            this.arrowPrev.classList.add(hiddenClass);
        } else {
            this.arrowPrev.classList.remove(hiddenClass);
        }

        // Next button visibility
        if (swiper.isEnd) {
            this.arrowNext.classList.add(hiddenClass);
        } else {
            this.arrowNext.classList.remove(hiddenClass);
        }
    }
}
